import * as React from 'react'
import { useQuery } from 'react-query'
import { api } from 'services'
import { optionsMapper, multiSelectorOptionsMapper } from '../utils'

type PlannerOption = {
  id: number
  user?: {
    id: number
    name: string
    email: string
  }
}

export const usePlannerOptions = () => {
  const fetchPlanners = React.useCallback(async (): Promise<{ label: string; value: string }[]> => {
  const { data: planners } = await api.get<PlannerOption[]>('/planners', {
    params: { asList: true },
  })

  return planners.map((planner) => ({
    label: planner.user?.name || 'Sem nome',
    value: planner.id.toString(),
  }))

    }, [])

  const { data, isLoading } = useQuery({
    queryKey: ['fetch-planners'],
    queryFn: fetchPlanners,
    refetchOnWindowFocus: false,
  })

  return {
    singleSelectOptions: data?.map(optionsMapper) || [],
    multiSelectOptions: data?.map(multiSelectorOptionsMapper) || [],
    loading: isLoading,
  }
}
